import React from 'react';
import { Box, Checkbox } from '@material-ui/core';
import classNames from 'classnames';
import { getWidgetNames } from './export-plan-section.util';

export function ExportPlanSectionItem({ classes, section, isSelected, onToggle }) {
  const widgetNames = getWidgetNames(section);

  return (
    <Box
      className={classNames(classes.sectionCard, {
        [classes.sectionCardSelected]: isSelected,
      })}
      data-testid={`export-section-${section.id}`}
    >
      <Box className={classes.sectionCardRow}>
        <Checkbox
          checked={isSelected}
          onChange={() => onToggle(section.id)}
          className={classes.checkbox}
          color="primary"
          inputProps={{ 'aria-label': `Select ${section.title}` }}
        />
        <Box flex={1}>
          <p className={classes.sectionTitle}>{section.title}</p>
          {section.description ? (
            <p className={classes.sectionDescription}>{section.description}</p>
          ) : null}
        </Box>
      </Box>
      {widgetNames.length > 0 ? (
        <Box className={classes.widgetList}>
          {widgetNames.map((name, index) => (
            <span key={`${section.id}-widget-${name}`} className={classes.widgetName}>
              {name}
              {index < widgetNames.length - 1 ? ',' : ''}
            </span>
          ))}
        </Box>
      ) : null}
    </Box>
  );
}
